/**
 * Starter JavaScript for disabling form submissions if there are invalid fields
 */

export default (() => {
  const forms = document.querySelectorAll('.webform-submission-form')

  if (forms.length === 0) return

  // forms.forEach((form) => {
  //   console.log('form', form);
  //   form.addEventListener(
  //     'submit',
  //     (event) => {
  //       if (!form.checkValidity()) {
  //         event.preventDefault()
  //         event.stopPropagation()
  //       }
  //
  //       form.classList.add('was-validated')
  //
  //       // Custom select validation on form submit
  //       const customSelects = form.querySelectorAll('.form-custom-select')
  //
  //       customSelects.forEach((customSelect) => {
  //         const selectInput = customSelect.querySelector('.visually-hidden')
  //         const selectButton = customSelect.querySelector('.form-select')
  //
  //         if (selectInput.validity.valid) {
  //           selectButton.classList.remove('is-invalid')
  //           selectButton.classList.add('is-valid')
  //         } else {
  //           selectButton.classList.remove('is-valid')
  //           selectButton.classList.add('is-invalid')
  //         }
  //       })
  //     },
  //     false
  //   )
  //
  //   // Custom select validation on change
  //   const customSelects = form.querySelectorAll('.form-custom-select')
  //
  //   customSelects.forEach((customSelect) => {
  //     const selectInput = customSelect.querySelector('.visually-hidden')
  //     const selectButton = customSelect.querySelector('.form-select')
  //
  //     customSelect.addEventListener('click', () => {
  //       if (form.classList.contains('was-validated')) {
  //         if (selectInput.validity.valid) {
  //           selectButton.classList.remove('is-invalid')
  //           selectButton.classList.add('is-valid')
  //         } else {
  //           selectButton.classList.remove('is-valid')
  //           selectButton.classList.add('is-invalid')
  //         }
  //       }
  //     })
  //   })
  // })
  // Chat link button
  document.querySelectorAll('.chatlink').forEach(function (chatLink) {
    chatLink.addEventListener('click', function () {
      let button = document.querySelector('.textchat-widget-bubble');
      if (button) {
        button.click();
      }
    });
  });

// Form validation
  var formEl = document.querySelector("form.webform-submission-form");

  if (formEl) {
    formEl.querySelectorAll('input, select, textarea').forEach(function (input) {
      input.addEventListener('blur', function () {
        var thisEl = this.parentElement;
        if (!thisEl.classList.contains('was-validated')) {
          thisEl.classList.add('was-validated');
        }
      });

      input.addEventListener('input', function () {
        var thisEl = this.parentElement;
        if (!thisEl.classList.contains('was-validated')) {
          thisEl.classList.add('was-validated');
        }
      });
    });
  }


})()
